// extracted by mini-css-extract-plugin
export default {"root":"ScrollableContainer_root__S8QB5"};